import { render } from "./TranslationsView.vue?vue&type=template&id=55604d40"
import script from "./TranslationsView.vue?vue&type=script&lang=js"
export * from "./TranslationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__